import React from 'react'

type Props = {
  children: any
}

export const SidenavContent: React.FC<Props> = ({children}) => {
  return (
    <div>
      {children}
    </div>
  )
} 
